import React from 'react';
import cn from 'classnames';

import styles from './header-menu-block.module.css';
import { InfoMenu } from '../info-menu/info-menu';
import { ChangeRegionButton } from '../change-region-button/change-region-button';
import { Tabs } from '../tabs/tabs';
import { TabsForPublicAreaMobile } from '../tabs-for-public-area-mobile/tabs-for-public-area-mobile';

export interface HeaderMenuBlockProps {
    isMenuOpened: boolean;
    isInfoMenuVisible?: boolean;
    userRegionName?: string;
    onChangeRegionClick: () => void;
    shouldShowPublicAreaMenuMobile?: boolean;
}

export const HeaderMenuBlock: React.FC<HeaderMenuBlockProps> = ({
    isMenuOpened,
    isInfoMenuVisible,
    userRegionName,
    onChangeRegionClick,
    shouldShowPublicAreaMenuMobile,
}) => {
    return (
        <div
            className={cn(styles.menu, {
                [styles.menuOpened]: isMenuOpened,
                [styles.menuOpenedAlternative]: shouldShowPublicAreaMenuMobile,
            })}
        >
            <div className={styles.infoMenu}>{isInfoMenuVisible && <InfoMenu />}</div>

            <div
                className={cn(styles.changeRegionButton, {
                    [styles.fixedChangeRegionButton]: shouldShowPublicAreaMenuMobile,
                })}
            >
                <ChangeRegionButton onClick={onChangeRegionClick} regionName={userRegionName} />
            </div>

            <div className={styles.regularTabs}>
                <Tabs />
            </div>

            <div className={styles.mobileTabsPublicArea}>
                <TabsForPublicAreaMobile />
            </div>
        </div>
    );
};
